import { Box, TextField } from '@mui/material'
import { updateFyaNotice } from 'api/services/automation/config'
import { updateFyaItem } from 'api/services/automation/income-tax'
import DialogWrapper from 'components/DialogWrapper'
// import FormDate from 'components/FormFields/FormDate'
import LoadingButton from 'components/LoadingButton'
import { snack } from 'components/toast'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { handleError } from 'utils/handleError'

let addFyaNotice = {
  din: "",
  issuedOn: null,
  responseDueDate: null,
  nameOfAssesse: "",
  description: "",
  pan: ""
}

interface fyaNotice {
  din: string;
  issuedOn: any;
  responseDueDate: any;
  nameOfAssesse: string;
  description: string;
  pan: string;
}

const EditFyaNotice = ({ open, setOpen, state, clientName }) => {
  const queryClient = useQueryClient()
  const { reset, control, register, handleSubmit } = useForm<fyaNotice>({
    defaultValues: addFyaNotice,
    mode: "onSubmit"
  })

  const { mutate, isLoading } = useMutation(updateFyaNotice, {
    onSuccess: () => {
      snack.success("Notice  Updated")
      queryClient.invalidateQueries("e-proceeding")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })



  const onSubmit = (item) => {
    console.log(item)

    if (item?.din?.trim().length < 5) {
      return snack.error("DIN is mandatory")
    }
    item.din = item?.din?.trim()
    item.description = item?.description?.trim()
    if (!item?.issuedOn) {
      return snack.error("Issued On is mandatory")
    }
    if (!item?.responseDueDate) {
      return snack.error("Response Due Date is mandatory")
    }

    const issuedOnDate = new Date(item.issuedOn);
    const responseDueDate = new Date(item.responseDueDate);

    if (issuedOnDate >= responseDueDate) {
      return snack.error("Response Due Date must be after Issued On date");
    }

    mutate({
      ...state,
      documentIdentificationNumber: item?.din,
      issuedOn: item?.issuedOn,
      responseDueDate: item?.responseDueDate,
      description: item?.description,
      nameOfAssesse: item?.nameOfAssesse?.trim(),
      pan: item?.pan?.trim()
    })
  }

  useEffect(() => {
    reset({
      din: state?.documentIdentificationNumber,
      issuedOn: state?.issuedOn,
      responseDueDate: state?.responseDueDate,
      description: state?.description,
      nameOfAssesse: state?.nameOfAssesse || "",
      pan: state?.pan || ""
    })
  }, [state, reset])
  return (
    <DialogWrapper open={open} setOpen={setOpen} title="Edit Notice">
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* <Box mt={1}>
            <TextField
              label="Name"
              fullWidth
              size='medium'
              value={clientName}
              disabled
            />
          </Box> */}
          <Box mt={1}>
            <TextField
              label="Notice Section"
              size='medium'
              value={state?.noticeSection || ""}
              fullWidth
              disabled
            />
          </Box>
          <Box mt={1}>

            <TextField
              label="Proceeding Name"
              size='medium'
              value={state.proceedingName || ""}
              fullWidth
              disabled
            />
          </Box>
          <Box mt={1}>
            <TextField
              label="Name Of Assesse"
              fullWidth
              size='medium'
              {...register(`nameOfAssesse` as const)}
            />
          </Box>

          <Box mt={1}>
            <TextField
              label="Assesse PAN"
              fullWidth
              size='medium'
              {...register(`pan` as const)}
            />
          </Box>
          <Box mt={1}>
            <TextField
              label="DIN"
              fullWidth
              size='medium'
              required
              {...control.register(`din` as const)}
            />
          </Box>
          {/* <Box mt={1}>
            <FormDate
              name="issuedOn"
              required
              control={control}
              label="Issued On"
            />
          </Box>
          <Box mt={1}>
            <FormDate
              name="responseDueDate"
              required
              control={control}
              label="Response Due Date"
            />
          </Box> */}
          <Box mt={1}>
            <TextField
              label="Description"
              fullWidth
              size='medium'
              {...control.register(`description` as const)}
            />
          </Box>
          <Box mt={1}>
            <LoadingButton
              loading={isLoading}
              disabled={isLoading}
              loadingColor='white'
              type="submit"
              title='Submit'
              color='secondary'
            />
          </Box>
        </form>
      </Box>
    </DialogWrapper>
  )
}

export default EditFyaNotice